// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toolbar 样式 - 微信公众号菜单风格 */
.Toolbar-wrapper {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

/* 分类项容器 */
.Toolbar-category-item {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 弹出工具面板 */
.Toolbar-popup {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 10px 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  animation: Toolbar-popup-slide-up 0.18s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  width: 200px;
  min-height: 60px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  z-index: 100;
  pointer-events: auto;
  will-change: transform, opacity;
  opacity: 0;
}

.Toolbar-popup::-webkit-scrollbar {
  width: 6px;
}

.Toolbar-popup::-webkit-scrollbar-track {
  background: transparent;
}

.Toolbar-popup::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.Toolbar-popup::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

@keyframes Toolbar-popup-slide-up {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* 底部分类菜单栏 */
.Toolbar-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 4px 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  gap: 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
  min-width: 420px;
  max-width: 90vw;
}

/* 分类标签按钮 */
.Toolbar-category-tab {
  flex: 1;
  min-width: 120px;
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  user-select: none;
  position: relative;
}

.Toolbar-category-tab:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  height: 60%;
  width: 1px;
  background: rgba(0, 0, 0, 0.1);
}

.Toolbar-category-tab:hover {
  background: rgba(102, 126, 234, 0.05);
  color: #667eea;
}

/* 激活的分类标签 */
.Toolbar-category-tab-active {
  color: #667eea;
  font-weight: 600;
}

.Toolbar-category-tab-active:hover {
  color: #667eea;
}

.Toolbar-category-tab-active::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  right: 10%;
  height: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px 3px 0 0;
}

.Toolbar-category-icon {
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
}

.Toolbar-category-label {
  font-weight: 500;
  letter-spacing: 0.3px;
  font-size: 14px;
}


.Toolbar-button {
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  cursor: grab;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 13px;
  user-select: none;
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  justify-content: flex-start;
}

.Toolbar-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  opacity: 0;
  transition: opacity 0.25s;
}

.Toolbar-button:hover {
  background: rgba(102, 126, 234, 0.06);
  border-color: rgba(102, 126, 234, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.Toolbar-button:hover::before {
  opacity: 1;
}

.Toolbar-button:active {
  cursor: grabbing;
  transform: translateY(0) scale(0.98);
}

.Toolbar-icon {
  font-size: 16px;
  width: 20px;
  flex: 0 0 20px;
  pointer-events: none;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Toolbar-label {
  color: #2c3e50;
  font-weight: 500;
  pointer-events: none;
  letter-spacing: 0.3px;
  position: relative;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/Toolbar.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;EACrC,6EAA6E;EAC7E,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,+CAA+C;EAC/C,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yEAAyE;EACzE,aAAa;EACb,MAAM;EACN,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sFAAsF;EACtF,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["/* Toolbar 样式 - 微信公众号菜单风格 */\n.Toolbar-wrapper {\n  position: absolute;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n}\n\n/* 分类项容器 */\n.Toolbar-category-item {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* 弹出工具面板 */\n.Toolbar-popup {\n  position: absolute;\n  bottom: calc(100% + 12px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 10px 14px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  animation: Toolbar-popup-slide-up 0.18s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n  width: 200px;\n  min-height: 60px;\n  max-height: 400px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n  z-index: 100;\n  pointer-events: auto;\n  will-change: transform, opacity;\n  opacity: 0;\n}\n\n.Toolbar-popup::-webkit-scrollbar {\n  width: 6px;\n}\n\n.Toolbar-popup::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.Toolbar-popup::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n\n.Toolbar-popup::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n@keyframes Toolbar-popup-slide-up {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* 底部分类菜单栏 */\n.Toolbar-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 4px 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);\n  display: flex;\n  gap: 0;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  min-width: 420px;\n  max-width: 90vw;\n}\n\n/* 分类标签按钮 */\n.Toolbar-category-tab {\n  flex: 1;\n  min-width: 120px;\n  padding: 12px 20px;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #666;\n  white-space: nowrap;\n  user-select: none;\n  position: relative;\n}\n\n.Toolbar-category-tab:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 20%;\n  height: 60%;\n  width: 1px;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.Toolbar-category-tab:hover {\n  background: rgba(102, 126, 234, 0.05);\n  color: #667eea;\n}\n\n/* 激活的分类标签 */\n.Toolbar-category-tab-active {\n  color: #667eea;\n  font-weight: 600;\n}\n\n.Toolbar-category-tab-active:hover {\n  color: #667eea;\n}\n\n.Toolbar-category-tab-active::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 10%;\n  right: 10%;\n  height: 3px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 3px 3px 0 0;\n}\n\n.Toolbar-category-icon {\n  font-size: 18px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n}\n\n.Toolbar-category-label {\n  font-weight: 500;\n  letter-spacing: 0.3px;\n  font-size: 14px;\n}\n\n\n.Toolbar-button {\n  width: 100%;\n  padding: 10px 14px;\n  background: transparent;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  cursor: grab;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 13px;\n  user-select: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n  justify-content: flex-start;\n}\n\n.Toolbar-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));\n  opacity: 0;\n  transition: opacity 0.25s;\n}\n\n.Toolbar-button:hover {\n  background: rgba(102, 126, 234, 0.06);\n  border-color: rgba(102, 126, 234, 0.3);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n}\n\n.Toolbar-button:hover::before {\n  opacity: 1;\n}\n\n.Toolbar-button:active {\n  cursor: grabbing;\n  transform: translateY(0) scale(0.98);\n}\n\n.Toolbar-icon {\n  font-size: 16px;\n  width: 20px;\n  flex: 0 0 20px;\n  pointer-events: none;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Toolbar-label {\n  color: #2c3e50;\n  font-weight: 500;\n  pointer-events: none;\n  letter-spacing: 0.3px;\n  position: relative;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
